import { render, staticRenderFns } from "./Offers.vue?vue&type=template&id=c070c3e8&scoped=true"
import script from "./Offers.vue?vue&type=script&lang=js"
export * from "./Offers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c070c3e8",
  null
  
)

export default component.exports